/* eslint-disable no-console */
import { DEV } from 'application/consts';

export type TLogUtils = {
  debug: (message: string, ...args: any[]) => false | void;
  info: (message: string, ...args: any[]) => false | void;
  warn: (message: string, ...args: any[]) => false | void;
  error: (message: string, error?: any) => void;
  pause: () => void;
  resume: () => void;
};

class Logger {
  private paused = false;

  private context: string;

  private color: string;

  constructor(context: string, color?: string) {
    this.context = context;
    this.color = color || '#ffffff';
  }

  private shouldLog(): boolean {
    return DEV && !this.paused;
  }

  private formatPrefix(): string {
    if (typeof window !== 'undefined' && this.color) {
      return `%c[${this.context}]`;
    }
    return `[${this.context}]`;
  }

  private getColorStyle(): string {
    return `color: ${this.color}; font-weight: bold;`;
  }

  debug(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.log(this.formatPrefix(), this.getColorStyle(), message, ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.info(this.formatPrefix(), this.getColorStyle(), message, ...args);
    }
  }

  warn(message: string, ...args: any[]) {
    if (this.shouldLog()) {
      console.warn(this.formatPrefix(), this.getColorStyle(), message, ...args);
    }
  }

  error(message: string, error?: any) {
    const prefix = this.formatPrefix();
    const style = this.getColorStyle();

    if (DEV && !this.paused) {
      console.error(prefix, style, message, error || '');
    } else if (!this.paused) {
      console.error(`Error: ${this.context} ${message}`);
    }
  }

  pause() {
    this.paused = true;
  }

  resume() {
    this.paused = false;
  }
}

export const createLogger = (context: string, color?: string): TLogUtils => new Logger(context, color);
